// features/settings/settingsApi.js
import { baseApi } from "../baseApi";

export const settingsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({

        // GET SETTINGS
        getSettings: builder.query({
            query: () => ({
                url: "/get-settings",
                method: "GET",
            }),
            providesTags: ["SETTINGS"],
        }),

        // UPDATE SETTINGS
        updateSettings: builder.mutation({
            query: (data) => ({
                url: "/update-settings",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["SETTINGS"],
        }),

        // UPDATE LOGO
        updateLogo: builder.mutation({
            query: (data) => ({
                url: "/update-logo",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["SETTINGS"],
        }),

        // UPDATE BANNER
        updateBannerImage: builder.mutation({
            query: (data) => ({
                url: "/update-banner",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["SETTINGS"],
        }),

        // DELETE IMAGE
        deleteImage: builder.mutation({
            query: (imageType) => ({
                url: `/delete-image/${imageType}`,
                method: "DELETE",
            }),
            invalidatesTags: ["SETTINGS"],
        }),

    }),
});

export const {
    useGetSettingsQuery,
    useUpdateSettingsMutation,
    useUpdateLogoMutation,
    useUpdateBannerImageMutation,
    useDeleteImageMutation,
} = settingsApi;